export default class SurveyModalSection {
    firstForm = document.querySelector('div[data-popup-modal="survey-first"]');
    secondForm = document.querySelector('div[data-popup-modal="survey-second"]');
    thirdForm = document.querySelector('div[data-popup-modal="survey-third"]');
    fourthForm = document.querySelector('div[data-popup-modal="survey-fourth"]');
    rating = {
        comfort: 0,
        accessory: 0,
        cleaning: 0,
        location: 0,
        feature: 0,
        personnel: 0,
        booking: 0,
        register: 0,
        contact: 0,
    };
    surveyFirstModal = 'survey-first';
    surveySecondModal = 'survey-second';
    surveyThirdModal = 'survey-third';
    surveyFourthModal = 'survey-fourth'
    surveyThanksModal = 'survey-thanks';
    notification = null;
    settings = null;
    locale = null;

    constructor(notification, settings, locale) {
        this.notification = notification;
        this.settings = settings;
        this.locale = locale;

        // ! TODO: wszystko poniżej jest do kompletnego refaktoru, kod jest skandalicznie długi i bezsensowny
        this.bindModal();
    }

    bindModal() {
        const { rating, firstForm, secondForm, thirdForm, fourthForm } = this;
        let orderId = 0;
        if (this.settings("surveyData") !== '') {
            orderId = Number(this.settings("surveyData").split('_')[1]);
        }

        if (firstForm !== null || secondForm !== null || thirdForm !== null || fourthForm !== null) {
            const firstNextButton = firstForm.querySelector('.btn-next');
            const secoundNextButton = secondForm.querySelector('.btn-next');
            const thirdNextButton = thirdForm.querySelector('.btn-next')
            const sendDataButton = fourthForm.querySelector('.btn-next');

            const buttonsFirstModal = firstForm.querySelectorAll('button');
            const buttonsSecondModal = secondForm.querySelectorAll('button');
            const buttonsThirdModal = thirdForm.querySelectorAll('button');

            const gradeAccessory = secondForm.querySelector('.grade-accessory');
            const gradeCleaning = firstForm.querySelector('.grade-cleaning');
            const gradeLocation = secondForm.querySelector('.grade-location');
            const gradePersonnel = firstForm.querySelector('.grade-personnel');
            const gradeBooking = thirdForm.querySelector('.grade-booking');
            const gradeRegister = thirdForm.querySelector('.grade-register');
            //const gradeContact = thirdForm.querySelector('.grade-contact');

            const accessoryComplainButtons = gradeAccessory.querySelectorAll('button');
            const cleaningComplainButtons = gradeCleaning.querySelectorAll('button');
            const locationComplainButtons = gradeLocation.querySelectorAll('button');
            const personnelComplainButtons = gradePersonnel.querySelectorAll('button');
            const bookingComplainButtons = gradeBooking.querySelectorAll('button');
            const registerComplainButtons = gradeRegister.querySelectorAll('button');

            const accessoryRating = gradeAccessory.querySelectorAll('.accessory');
            const cleaningRating = gradeCleaning.querySelectorAll('.cleaning');
            const locationRating = gradeLocation.querySelectorAll('.location');
            const personnelRating = gradePersonnel.querySelectorAll('.personnel');
            const bookingRating = gradeBooking.querySelectorAll('.booking');
            const registerRating = gradeRegister.querySelectorAll('.register');

            const otherReasonAccessory = gradeAccessory.querySelector('.other');
            const otherReasonCleaning = gradeCleaning.querySelector('.other');
            const otherReasonLocation = gradeLocation.querySelector('.other');
            const otherReasonPersonnel = gradePersonnel.querySelector('.other');
            const otherReasonBooking = gradeBooking.querySelector('.other');
            const otherReasonRegister = gradeRegister.querySelector('.other');

            //const surveycontact = gradeContact.querySelector('#surveycontact');
            const userOpinionElement = fourthForm.querySelector('textarea');

            const photoUpload = fourthForm.querySelector('#photoUpload');
            const photoPreview = fourthForm.querySelector('.survey-photos__preview');

            this.showSurveyReason();


            let allFiles = [];

            userOpinionElement.addEventListener('change', () => {
                if (userOpinionElement.value.length > 1000) {
                    this.notification.show(this.notification.types.error, this.locale("exceededMaxCharacters"));
                    if (!userOpinionElement.classList.contains('textarea-error')) {
                        userOpinionElement.classList.add('textarea-error');
                    }
                } else {
                    if (userOpinionElement.classList.contains('textarea-error')) {
                        userOpinionElement.classList.remove('textarea-error');
                    }
                }
            });


            photoUpload.addEventListener('change', () => {
                const maxFiles = 3;
                const maxTotalSize = 4 * 1024 * 1024;
                const allowedExtensions = ['jpg','jpeg','png','heif','heic'];

                const totalFileCount = allFiles.length + photoUpload.files.length;
                if (totalFileCount > maxFiles) {
                    this.notification.show(this.notification.types.error, this.locale("tooManyFilesError"));
                    return;
                }
                
                let newFilesSize = 0;
                let hasValidFiles = false;
                for (let i = 0; i < photoUpload.files.length; i++) {
                    const file = photoUpload.files[i];
                    const fileName = file.name.toLowerCase();
                    const fileExtension = fileName.split('.').pop();
                    const isHeic = fileExtension === 'heic' || fileExtension === 'heif'

                    if ((!file.type.match('image.*') && !isHeic )|| !allowedExtensions.includes(fileExtension)) {
                        this.notification.show(this.notification.types.error, this.locale("badFileExtensionError"));
                        continue;
                    }
                    newFilesSize += file.size;
                    hasValidFiles = true;

                }

                if(hasValidFiles){
                    const currentTotalSize = this.calculateTotalSize(allFiles);
                    if(currentTotalSize + newFilesSize > maxTotalSize) {
                        const newFilesMB = (newFilesSize / (1024 * 1024)).toFixed(2);
                        this.notification.show(this.notification.types.error, this.locale("exceededMaxFilesSize"));
                        return;
                    }
                }


                for (let i = 0; i < photoUpload.files.length; i++) {
                    const file = photoUpload.files[i];
                    const fileName = file.name.toLowerCase();
                    const fileExtension = fileName.split('.').pop();
                    const isHeic = fileExtension === 'heic' || fileExtension === 'heif'

                    if ((!file.type.match('image.*') && !isHeic )|| !allowedExtensions.includes(fileExtension)) {
                        this.notification.show(this.notification.types.error, this.locale("badFileExtensionError"));
                        continue;
                    }

                    allFiles.push(file);

                    const fileIndex = allFiles.length - 1;

                    const reader = new FileReader();
                    reader.onload = (e) => {
                        const previewItem = document.createElement('div');
                        previewItem.className = 'preview-item';
                        previewItem.dataset.fileIndex = fileIndex;

                        const img = document.createElement('img');
                        img.src = e.target.result;
                        img.className = 'preview-image';

                        const deleteBtn = document.createElement('button');
                        deleteBtn.className = 'delete-btn';
                        deleteBtn.innerHTML = '×';

                        deleteBtn.addEventListener('click', () => {
                            const indexToRemove = parseInt(previewItem.dataset.fileIndex);

                            allFiles.splice(indexToRemove,1);
                            previewItem.remove();

                            const remainingItems = photoPreview.querySelectorAll('.preview-item');
                            remainingItems.forEach((item, idx) => {
                                item.dataset.fileIndex = idx;
                            });
                            this.updateSizeInfo(allFiles);

                        });

                        previewItem.appendChild(img);
                        previewItem.appendChild(deleteBtn);

                        photoPreview.appendChild(previewItem);
                    }

                    reader.readAsDataURL(file);
                }

                photoUpload.files = allFiles.files;
                this.updateSizeInfo(allFiles);
                photoUpload.value = '';
            });
            //rating
            //first page


            accessoryRating.forEach((ratings, i) => {
                ratings.addEventListener('click', () => {
                    const ratingReason = gradeAccessory.querySelector('.rating-reason');
                    let currentRating = this.surveyCorrectRating(i + 1);
                    rating.accessory = currentRating;

                });
            });

            cleaningRating.forEach((ratings, i) => {
                ratings.addEventListener('click', () => {
                    const ratingReason = gradeCleaning.querySelector('.rating-reason');
                    let currentRating = this.surveyCorrectRating(i + 1);
                    rating.cleaning = currentRating;

                });
            });

            //second page
            locationRating.forEach((ratings, i) => {
                ratings.addEventListener('click', () => {
                    const ratingReason = gradeLocation.querySelector('.rating-reason');
                    let currentRating = this.surveyCorrectRating(i + 1);
                    rating.location = currentRating;


                });
            });



            //third page
            personnelRating.forEach((ratings, i) => {
                ratings.addEventListener('click', () => {
                    const ratingReason = gradePersonnel.querySelector('.rating-reason');
                    let currentRating = this.surveyCorrectRating(i + 1);
                    rating.personnel = currentRating;

                });
            });

            bookingRating.forEach((ratings, i) => {
                ratings.addEventListener('click', () => {
                    const ratingReason = gradeBooking.querySelector('.rating-reason');
                    let currentRating = this.surveyCorrectRating(i + 1);
                    rating.booking = currentRating;

                });
            });

            registerRating.forEach((ratings, i) => {
                ratings.addEventListener('click', () => {
                    const ratingReason = gradeRegister.querySelector('.rating-reason');
                    let currentRating = this.surveyCorrectRating(i + 1);
                    rating.register = currentRating;

                });
            });


            //button
            buttonsFirstModal.forEach(item => {
                item.addEventListener('click', () => {
                    if (item.classList.contains('active')) {
                        item.classList.remove('active');
                    } else {
                        item.classList.add('active');
                    }
                });
            });

            buttonsSecondModal.forEach(item => {
                item.addEventListener('click', () => {
                    if (item.classList.contains('active')) {
                        item.classList.remove('active');
                    } else {
                        item.classList.add('active');
                    }
                });
            });

            buttonsThirdModal.forEach(item => {
                item.addEventListener('click', () => {
                    if (item.classList.contains('active')) {
                        item.classList.remove('active');
                    } else {
                        item.classList.add('active');
                    }
                });
            });

            firstNextButton.addEventListener('click', () => {
                if (rating.personnel !== 0 && rating.cleaning !== 0) {
                    let isAllValid = true;
                    if (isAllValid) {
                        modal.close(this.surveyFirstModal);
                        modal.open(this.surveySecondModal);
                    }
                } else {
                    this.notification.show(this.notification.types.error, this.locale("rateYourStay"));
                }
            });

            secoundNextButton.addEventListener('click', () => {
                if (rating.location !== 0 && rating.accessory) {
                    let isAllValid = true;
                    if (isAllValid) {
                        modal.close(this.surveySecondModal);
                        modal.open(this.surveyThirdModal);
                    }
                } else {
                    this.notification.show(this.notification.types.error, this.locale("rateYourStay"));
                }
            });

            thirdNextButton.addEventListener('click', () => {
                if (rating.booking !== 0 && rating.register !== 0) {
                    let isAllValid = true
                    if (isAllValid) {
                        modal.close(this.surveyThirdModal);
                        modal.open(this.surveyFourthModal);
                    }
                } else {
                    this.notification.show(this.notification.types.error, this.locale("rateYourStay"));
                }
            });



            sendDataButton.addEventListener('click', async () => {
                sendDataButton.disabled = true;
                
                if (rating.booking !== 0 && rating.register !== 0) {
                    let isAllValid = true;

                    let comfortComplain = '';
                    let accessoryComplain = '';
                    let cleaningComplain = '';
                    let locationComplain = '';
                    let featureComplain = '';
                    let personnelComplain = '';
                    let bookingComplain = '';
                    let registerComplain = '';

                    let comfortTextarea = '';
                    let accessoryTextarea = '';
                    let cleaningTextarea = '';
                    let locationTextarea = '';
                    let featureTextarea = '';
                    let personnelTextarea = '';
                    let bookingTextarea = '';
                    let registerTextarea = '';



                    if (userOpinionElement.value.length > 1000) {
                        isAllValid = false;

                        // this.notification.show(this.notification.types.error, this.locale("exceededMaxCharacters"));
                        // if (!userOpinionElement.classList.contains('textarea-error')) {
                        //     userOpinionElement.classList.add('textarea-error');
                        // }
                    }




                    if (rating.accessory < 9 && rating.accessory > 0) {
                        if (otherReasonAccessory.classList.contains('active')) {
                            accessoryTextarea = gradeAccessory.querySelector('textarea').value;
                        }

                        accessoryComplainButtons.forEach(item => {
                            if (item.classList.contains('active')) {
                                accessoryComplain += item.getAttribute('data-value') + ',';
                            }
                        });
                    }

                    if (rating.cleaning < 9 && rating.cleaning > 0) {
                        if (otherReasonCleaning.classList.contains('active')) {
                            cleaningTextarea = gradeCleaning.querySelector('textarea').value;
                        }

                        cleaningComplainButtons.forEach(item => {
                            if (item.classList.contains('active')) {
                                cleaningComplain += item.getAttribute('data-value') + ',';
                            }
                        });
                    }

                    if (rating.location < 9 && rating.location > 0) {
                        if (otherReasonLocation.classList.contains('active')) {
                            locationTextarea = gradeLocation.querySelector('textarea').value;
                        }

                        locationComplainButtons.forEach(item => {
                            if (item.classList.contains('active')) {
                                locationComplain += item.getAttribute('data-value') + ',';
                            }
                        });
                    }

                    if (rating.booking < 9 && rating.booking > 0) {
                        let bookingTxt = gradeBooking.querySelector('textarea');
                        if (otherReasonBooking.classList.contains('active')) {
                            bookingTextarea = gradeBooking.querySelector('textarea').value
                        }

                        if (bookingTextarea.length > 400) {
                            isAllValid = false;

                            this.notification.show(this.notification.types.error, this.locale("exceededMaxCharacters"));
                            if (!bookingTxt.classList.contains('textarea-error')) {
                                bookingTxt.classList.add('textarea-error');
                            }
                        } else {
                            if (bookingTxt.classList.contains('textarea-error')) {
                                bookingTxt.classList.remove('textarea-error');
                            }
                        }

                        bookingComplainButtons.forEach(item => {
                            if (item.classList.contains('active')) {
                                bookingComplain += item.getAttribute('data-value') + ',';
                            }
                        });
                    }

                    if (rating.register < 9 && rating.register > 0) {
                        let registerTxt = gradeRegister.querySelector('textarea');
                        if (otherReasonRegister.classList.contains('active')) {
                            registerTextarea = gradeRegister.querySelector('textarea').value
                        }

                        if (registerTextarea.length > 400) {
                            isAllValid = false;

                            this.notification.show(this.notification.types.error, this.locale("exceededMaxCharacters"));
                            if (!registerTxt.classList.contains('textarea-error')) {
                                registerTxt.classList.add('textarea-error');
                            }
                        } else {
                            if (registerTxt.classList.contains('textarea-error')) {
                                registerTxt.classList.remove('textarea-error');
                            }
                        }

                        registerComplainButtons.forEach(item => {
                            if (item.classList.contains('active')) {
                                registerComplain += item.getAttribute('data-value') + ',';
                            }
                        });
                    }
                    if (isAllValid) {
                        let isVisibleOnPobyty = 0;
                        let contactWish = 0
                        //let contactWish = surveycontact.checked ? 1 : 0;
                        let otherComplainIds = ['', '', accessoryTextarea, cleaningTextarea, locationTextarea, '', personnelTextarea, bookingTextarea, registerTextarea];
                        let complainIds = ['', '', accessoryComplain, cleaningComplain, locationComplain, '', personnelComplain, bookingComplain, registerComplain];
                        let ratingPkt = [0, 0, rating.accessory, rating.cleaning, rating.location, 0, rating.personnel, rating.booking, rating.register];
                        let ratingPktSum = 0;
                        let ratingPktAverage = 0;
                        let userOpinion = userOpinionElement.value;

                        const surveyData = new FormData();
                        surveyData.append('OrderId', orderId);
                        surveyData.append('IsVisibleOnPobyty', isVisibleOnPobyty);
                        surveyData.append('ContactWish', contactWish);
                        surveyData.append('UserOpinion', userOpinion);
                        for (let type = 1; type < 9; type++) {
                            let id = type - 1;
                            surveyData.append(`SurveyComplains[${id}].Type`, type);
                            surveyData.append(`SurveyComplains[${id}].Rating`, ratingPkt[type]);
                            surveyData.append(`SurveyComplains[${id}].ComplainsIds`, complainIds[type]);
                            surveyData.append(`SurveyComplains[${id}].OtherComplains`, otherComplainIds[type]);
                        }
                        for (let i = 0; allFiles.length && i < 3; i++) {
                            surveyData.append(`Pictures`, allFiles[i])
                        }
                        const response = await fetch(this.settings("url").surveySendData, {
                            method: 'POST',
                            body: surveyData,
                            processData: false,
                            contentType: false,
                        });

                        /*                        let surveyResult = {
                                                    "order_id": orderId,
                                                    "contact": contactWish,
                                                    "complain_ids": complainIds,
                                                    "rating_pkt": ratingPkt,
                                                    "other_complain_ids": otherComplainIds,
                                                };
                                                let postData = `OrderId=${orderId}&ComplainIds=${complainIds[type]}&Type=${type}&Rating=${ratingPkt[type]}&OtherComplains=${otherComplainIds[type]}`;
                        
                                                const response = await fetch(this.settings.url.surveySendData, {
                                                    method: 'POST',
                                                    body: postData,
                                                    headers: {
                                                        'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
                                                        'X-Requested': 'With: XMLHttpRequest'
                                                    }
                                                });
                                                const res = await response.text();*/
                        /* for (let type = 1; type < 9; type++) {
                             let postData = `OrderId=${orderId}&IsVisibleOnPobyty=${isVisibleOnPobyty}&ContactWish=${contactWish}&ComplainIds=${complainIds[type]}&Type=${type}&Rating=${ratingPkt[type]}&OtherComplains=${otherComplainIds[type]}`;
                             console.log(postData)
                             ratingPktSum += ratingPkt[type];
                             const response = await fetch(this.settings("url").surveySendData, {
                                 method: 'POST',
                                 body: postData,
                                 headers: {
                                     'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
                                     'X-Requested': 'With: XMLHttpRequest'
                                 }
                             });
                             const res = await response.text();
                         }
                         */
                        ratingPktAverage = ratingPktSum / 8;
                        if (ratingPktAverage >= 4.5) {
                            const googleTravel = document.getElementById('googleTravel');
                            googleTravel.style.display = 'block';
                        }

                        modal.close(this.surveyFourthModal);
                        modal.open(this.surveyThanksModal);
                    }else{
                        sendDataButton.disabled = false;
                    }

                } else {
                    sendDataButton.disabled = false;
                    this.notification.show(this.notification.types.error, this.locale("rateYourStay"));
                }
            });
        }
    }

    calculateTotalSize(files) {
        return files.reduce((total,file) => total + file.size, 0);
    }

    
    updateSizeInfo(files){
        const totalSize = this.calculateTotalSize(files);
        const totalSizeMB = (totalSize / (1024 * 1024)).toFixed(2);
        const currentSizeSpan = document.getElementById('currentSize');
        currentSizeSpan.textContent = totalSizeMB;
    }

    surveyCorrectRating = (rating) => {
        return 11 - rating;
    }

    showSurveyReason = () => {
        const { rating, firstForm, secondForm, thirdForm } = this;

        if (firstForm !== null || secondForm !== null || thirdForm !== null) {
            const gradeAccessory = secondForm.querySelector('.grade-accessory');
            const gradeCleaning = firstForm.querySelector('.grade-cleaning');
            const gradeLocation = secondForm.querySelector('.grade-location');
            const gradePersonnel = firstForm.querySelector('.grade-personnel');
            const gradeBooking = thirdForm.querySelector('.grade-booking');
            const gradeRegister = thirdForm.querySelector('.grade-register');



            const accessory = gradeAccessory.querySelector('.rating-reason');
            if (rating.accessory < 9 && rating.accessory !== 0) {
                if (accessory.classList.contains('d-none')) {
                    accessory.classList.remove('d-none');
                }
            } else {
                if (!accessory.classList.contains('d-none')) {
                    accessory.classList.add('d-none');
                }
            }

            const cleaning = gradeCleaning.querySelector('.rating-reason');
            if (rating.cleaning < 9 && rating.cleaning !== 0) {
                if (cleaning.classList.contains('d-none')) {
                    cleaning.classList.remove('d-none');
                }
            } else {
                if (!cleaning.classList.contains('d-none')) {
                    cleaning.classList.add('d-none');
                }
            }

            const location = gradeLocation.querySelector('.rating-reason');
            if (rating.location < 9 && rating.location !== 0) {
                if (location.classList.contains('d-none')) {
                    location.classList.remove('d-none');
                }
            } else {
                if (!location.classList.contains('d-none')) {
                    location.classList.add('d-none');
                }
            }


            const personnel = gradePersonnel.querySelector('.rating-reason');
            if (rating.personnel < 9 && rating.personnel !== 0) {
                if (personnel.classList.contains('d-none')) {
                    personnel.classList.remove('d-none');
                }
            } else {
                if (!personnel.classList.contains('d-none')) {
                    personnel.classList.add('d-none');
                }
            }

            const booking = gradeBooking.querySelector('.rating-reason');
            if (rating.booking < 9 && rating.booking !== 0) {
                if (booking.classList.contains('d-none')) {
                    booking.classList.remove('d-none');
                }
            } else {
                if (!booking.classList.contains('d-none')) {
                    booking.classList.add('d-none');
                }
            }

            const register = gradeRegister.querySelector('.rating-reason');
            if (rating.register < 9 && rating.register !== 0) {
                if (register.classList.contains('d-none')) {
                    register.classList.remove('d-none');
                }
            } else {
                if (!register.classList.contains('d-none')) {
                    register.classList.add('d-none');
                }
            }
        }
    }
}